<div class="page-container">
  <pvmo-page id="page-administration" [hidden]="!isUserConnected()">
  </pvmo-page>
</div>

